import { priceList } from './calculator'
import { combineCostSources } from '../../utils'
import { currencyFactor } from './calculator'

const getTransactionFactor = (seconds) => {
    let min = 0.895
    let max = 1.375
    //We want to change factor in steps above 0.835 when nSeconds is larger than 45 and less than 3000

    let factor = ((max - min) / (3000 - 45)) * seconds
    let result = Number((min + factor).toFixed(4))
    if (result > max) result = max
    return result
}

const calculateClipLengthCost = (length, profiles = 1) => {
    if (length < 1) return 0
    let discountFactors = [1, 0.7, 0.65, 0.6, 0.55, 0.5, 0.45, 0.4, 0.35]
    let result = 0
    for (let i = 0; i < profiles; i++) {
        result += calculateTransactionPrice(
            length * 60,
            1.88,
            discountFactors[i]
        )
    }
    return result
}

const calculateTransactionPrice = (
    length,
    minPrice = priceList.mbox.price.min,
    mimeFactor = 1.0
) => {
    let result =
        (Math.log(length) / Math.log(3)) *
        getTransactionFactor(length) *
        mimeFactor

    if (result < minPrice) result = minPrice

    return result * currencyFactor
}

const calculateS3DownloadCost = (lengthInMinutes, mbps, downloads) => {
    const megabytes = (lengthInMinutes * 60 * mbps) / 8
    const gigabytes = megabytes / 1000
    return (
        gigabytes *
        downloads *
        priceList.quicklink.price.download.gb *
        priceList.quicklink.factor.download *
        currencyFactor
    )
}

const processQuicklinkItem = (item, result) => {
    const { value, downloads, downloadFactor, avgLength } = item

    const viewCost =
        value *
        calculateClipLengthCost(avgLength, 1) *
        priceList.quicklink.factor.view

    const downloadCost =
        downloads * calculateClipLengthCost(avgLength, 1) * downloadFactor

    result.sources['quicklinkDownloads'] += Math.round(downloadCost)
    result.sources['quicklinkViews'] += Math.round(viewCost)
}

const processMboxItem = (item, result) => {
    const f =
        item.complexity === 'custom'
            ? item.factor
            : priceList.mbox.factor[item.complexity]

    const cost =
        item.value * calculateClipLengthCost(item.avgLength, item.profiles) * f

    const downloadCost = calculateS3DownloadCost(
        item.avgLength,
        item.bitrate,
        item.s3Downloads
    )

    result.sources['s3Downloads'] += Math.round(downloadCost)
    result.sources[item.complexity] += Math.round(cost)
}

const processMobileUploadItem = (item, result) => {
    const { mediaLength, numberOfFiles } = item

    const cost = numberOfFiles * calculateClipLengthCost(mediaLength, 1)

    result.sources['mobileUploads'] += Math.round(cost)
    result.total += Math.round(cost)
}

const process = {
    quicklink: processQuicklinkItem,
    mbox: processMboxItem,
    mobileUpload: processMobileUploadItem
}

/**
 * Calculates the cost of all transaction based products
 * This includes M-Boxes, quinklinks, downloads and mobile uploads
 * @param {object} groups
 */
export const calculateTransactionCost = (groups) => {
    let result = {
        total: 0,
        blocks: {}
    }

    Object.keys(groups).forEach((groupKey) => {
        const { items, suffix } = groups[groupKey]
        const block = suffix || groupKey
        result.blocks[block] = {
            total: 0,
            sources: {
                low: 0,
                standard: 0,
                high: 0,
                custom: 0,
                quicklinkViews: 0,
                quicklinkDownloads: 0,
                s3Downloads: 0,
                mobileUploads: 0
            }
        }

        Object.keys(items).forEach((itemKey) => {
            const item = items[itemKey]
            process[item.type](item, result.blocks[block])
        })

        result.blocks[block].total = combineCostSources(
            result.blocks[block].sources
        )
        result.total += result.blocks[block].total
    })

    return result
}
